<template>
    <div class="main" :class="{mobile:isMobile, desktop:!isMobile}">
        <div v-if="chat.convs.length<=0" style="text-align:center;padding:24px;">
            <icon name="comments-o" size="58" />
            <br/>
            <h2>У Вас нет переписок.</h2> Вам напишут как только вы сделаете первый заказ
        </div>
        <div v-if="!currentConv" class="chats">
            <div :key="conv._id" v-for="conv in chat.convs" class="contact" @click="openConversation(conv._id)">
                <div :style="{backgroundImage:`url(${conv.friend.avatar})`}" class="avatar" style="margin-right:10px"/>
                <div class="info"> {{conv.friend.info.name}} {{conv.friend.info.surname}}</div>
                <span v-if="conv.friend.block" class="fa fa-ban" />
                <span v-if="!conv.friend.allow" class="fa fa-clock-o" />
                <span v-if="!conv.userConfig.allow" class="fa fa-user-plus" />
                <icon name="angle-right" size="38" style="float:right"/>
                <div v-if="conv.unread_message_qty>0" class="notif">{{conv.unread_message_qty}}</div>
            </div>
        </div>
        <div v-if="currentConv">
            <div class="infoBar">
                <btn @press="onBack" pull="left" type="info" size="large" icon="chevron-left" />
                <div class="chatInfo">
                    <div :style="{backgroundImage:`url(${currentConv.friend.avatar})`}" class="avatar" />
                    <span>{{currentConv.friend.info.name}} {{currentConv.friend.info.surname}}</span>
                    <br/>
                    <span :style="{fontSize:10}">{{currentConv.lastSeen}}</span>
                </div>
                <btn @press="showPhone" pull="right" type="info" size="large" icon="phone" />
            </div>
            <div class="messages scrollable" id="chat_messages" :style="{height:(height-(isMobile?176:106))+'px'}">
                <div v-if="!currentConv.friend.allow" class="notePanel">{{texts.USER_NOT_CONFIRM_YOU}}</div>
                <div v-if="currentConv.friend.block" class="notePanel">{{texts.USER_BLOCKED_YOU}}</div>
                <div v-if="!currentConv.userConfig.allow" class="notePanel">{{texts.NEW_CONVERSATION}}</div>
                <div class="message" v-for="msg in currentConv.messages">
                    <div style="width:46px;">
                        <div :style="{backgroundImage:`url(${msg.fromer.avatar})`}" class="avatar" />
                    </div>
                    <div style="margin-left:55px;">
                        <b v-if="msg.fromer.info">{{msg.fromer.info.name}} {{msg.fromer.info.surname}}</b>
                        <br/>
                        <span class="msg-text">{{msg.text}}</span>
                        <div class="msg-date">
                            {{msg.date | calendar}}
                        </div>

                    </div>
                </div>
            </div>
            <div class="sendBox">
                <!-- <btn :disabled="!currentConv.friend.allow" type="info" size="large" icon="paperclip" /> -->
                <input ref='chatInput' style='border-radius:4px;' :disabled="!currentConv.friend.allow" :value="message" clear={true} class="messageBox" :style="{marginLeft:'10px', height:38, display: 'inline-block',width:(width-128)+'px'}" placeholder="Напишите сообщение" @change="change" @keyup="sendOnEnter" />
                <!-- <btn :disabled="!currentConv.friend.allow" type="info" size="large" icon="smile-o" /> -->
                <btn  :disabled="!currentConv.friend.allow" @press="sendMessage" label='Отправить' type="info" size="large"  />
            </div>
        </div>
    </div>
</template>
<script>
//let io = require('socket.io-client');
let audio = document.createElement('audio');
audio.src = "assets/new_message.mp3";

let mounted = false;
export default {
    name: "chat",
    props: {
        d:String,
        width: {
            type: Number,
            default:window.innerWidth
        }
    },
    methods: {
        showPhone(){
            this.$http.post('chat/get_phone', { convId }).then((res)=>{
                console.log(res);
            });
        },
        openConversation(convId) {

            this.$http.post('chat/messages_readed', { convId });
            this.$store.commit("chatOpenConversation", convId);
            this.currentConversationId = convId;
            this.toBot();
        },
        deleteConversation() {
            this.$http.delete('/chat/conversations', { convId });
        },
        createConversation(userId) {
            this.$http.post('/chat/conversations', { userId }).then((res) => {
                this.$store.commit("createConversation", res.body.conv);
            });
        },
        loadMessages(convId) {
            this.$http.get(`/chat/messages/${convId}`).then((res) => {
                this.$store.commit("loadMessages", { convId, messages: res.body.messages });
            });
        },
        sendOnEnter(e) {
            if (e.keyCode === 13) this.sendMessage();
        },
        onBack() {
            this.$store.commit("chatOpenConversation", false)
        },
        change(e) {
            this.message = e.target.value;
        },
        sendMessage() {
            this.$refs.chatInput.focus();
            this.$http.post("chat/messages", { convId: this.currentConv._id, text: this.message }).then((res) => {
                this.toBot();
            });
            this.message = "";
        },
        toBot(){
            setTimeout(() => {
                let dv = document.getElementById('chat_messages');
                if(dv){
                    dv.scrollTop = dv.scrollHeight + 9000;
                }
            }, 100);
        },
        auth(){
            let self = this;
            this.$http.get("chat/auth").then((res)=>{
                let token = res.body.token;
                var socket = io(`http://${window.serverHost}:3002?token=${token}`);
                this.socket = socket;
                socket.on('connect', () => {
                    console.log("CONNECTED!")
                });

                socket.on('disconnect', () => {
                    console.warn('user disconnected, try to connect');
                    socket.close();
                    setTimeout(()=>{
                        self.auth();
                    },1000);
                });
                socket.on('auth_done', () => {
                    console.log("WEBSOCKET AUTH DONE");
                });
                socket.on('conversation_update', (conv) => {
                    this.$store.commit("conversationUpdated", conv);
                    self.updater = self.updater + 1;
                });
                socket.on('new_message', (msg) => {
                    this.toBot();
                    //console.log("BOT")
                    //console.log(this.toBot)
                    audio.play();
                    this.$store.dispatch("sendMessage", msg);
                    self.$forceUpdate();
                });

            });
        }
    },
    mounted() {
        if(!mounted){
            this.$http.get("chat/conversations").then((res) => {
                this.$store.dispatch("convsLoaded", res.body.convs);
            });
            this.auth();
            mounted = true;
        }
    },
    computed: {
        chat() { return this.$store.state.chat },
        currentConv() {
            if(this.updater){
                let state = this.$store.state.chat;
                if(!this.currentConversationId) return false;
                let found = state.convs.find(c=>c._id === this.currentConversationId);
                if(!found) return false;
                console.log(found);
                return found;
            }
        },
        isMobile(){
            return this.d !== "";
        }
    },
    data() {
        return {
            currentConversationId:false,
            height: window.innerHeight,
            updater:1,
            message: "",
            texts: {
                "USER_NOT_CONFIRM_YOU": "Этот пользователь еще не подтвердил вас",
                "USER_BLOCKED_YOU": "Этот пользователь заблокировал вас",
                "NEW_CONVERSATION": "Этот пользователь хочет начать с вами переписку. Напишите ему что нибудь, чтобы подтвердить приглашение",
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.main.mobile {
    padding: 0;
    transition: 0.3s all ease;
    background: white;
}


.left {
    border-right: 1px solid lightgrey;
    float: left;
    height: 100%;
    margin: 0;
}

.right {
    float: left;
    margin: 0;
}

.chats {
    height: 100%;
    border-bottom: 1px solid lightgrey;
}

.contact {
    border-bottom: 1px solid whitesmoke;
    padding: 8px 12px;
    overflow: hidden;
}

.contact:hover {
    background: whitesmoke;
    cursor: pointer;
}

.avatar {
    width: 46px;
    height: 46px;
    border-radius: 100%;
    background-size: cover;
    border: 1px solid lightgrey;
    background-position: center;
    float: left;
}


.infoBar,
.chatBox,
.searchBox {
    border-bottom: 1px solid lightgrey;
}

.infoBar {
    overflow: hidden;
}

.chatInfo {
    float: left; //width: 253px;
    padding: 4px; //width:100%;
    padding: 3px 6px;
}

.chatBox {
    overflow-y: scroll;
}

.message {
    overflow: hidden;
    margin: 12px 5px;
    border-bottom:1px solid whitesmoke;
    margin-bottom:10px;
    padding-bottom:10px;
}

.messages {
    overflow-y: scroll;
    padding: 8px;
}

.control {
    margin: 0 2px;
}


.searchResults {
    background: white;
    position: absolute;

    border: 1px solid lightgrey;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: -6px;
    margin-left: 4px;
    width: 210px;
}

.searchResults .contact:last-child {
    border-bottom: none;
}

.strip {
    background: lightgrey;
    color: white;
    font-size: 10px;
    padding: 0px 4px 2px;
}


.notePanel {
    padding: 5px;
    margin: 10px auto 2px;
    /* border: 1px solid lightgrey; */
    border-radius: 2px;
    max-width: 200px;
    text-align: center;
    /* background-image: linear-gradient(to bottom,#5cabb8 0%,#417b96 100%); */
    /* border-color: #3e768f; */
    background: rgba(91, 197, 253, 0.64);
    color: white;
}



.notif {
    border-radius: 100%;
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    display: inline-block;
    float: right;
    background: rgba(0, 196, 255, 0.72);
    text-align: center;
    margin: 4px;
    color: white;
}




@keyframes pulse {
    from {
        transform: scale3d(1, 1, 1);
    }

    50% {
        transform: scale3d(1.05, 1.05, 1.05);
    }

    to {
        transform: scale3d(1, 1, 1);
    }
}

.backFade {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    height: 100%;
    transition: 0.3s all ease;
}

.sendBox {
    display: fixed;
    bottom: 0;
    border-top: 1px solid lightgrey;
}

.chatBox {
    height: 50%;
}


.messageBox {
    font-size: 20px;
    height: 46px;
    outline: 0;

    width: 240px;
    padding: 4px;
    border: none;
}

.btn>>>.fa {
    font-size: 24px !important;
}
.contact .info{
    float:left;
    padding:14px 0 0 0px;
}

    .msg-text{
        word-break: break-word;
        display: inline-block;
    }

    .msg-date{
        margin-top:10px;
        text-align:right;
        font-size: 10px ;
        color:grey  ;

    }
</style>